import React from 'react';
import { Modal, Button } from '../ui-kit';

const ReturnToNormalModeModal = props => (
  <Modal show={true}>
    <Modal.Body> {I18n.t('dashboards.return_to_normal_mode')} </Modal.Body>
    <Modal.Footer>
      <Button variant="success" onClick={props.returnToNormalMode}>
        {I18n.t('save')}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ReturnToNormalModeModal;
